export default "__VITE_ASSET__B$ufDHC1__"